import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class HttpClientService {
    constructor(private _httpClient: HttpClient) { }

    get<T>(url: string, header: any) {
        return this._httpClient.get<T>(url, header);
    }

    delete<T>(url: string, header: any) {
        return this._httpClient.delete(url, header);
    }

    post<T>(url: string, data: any, header: any) {
        return this._httpClient.post(url, data, header);
    }
}
